import { useState } from "react";

export type Duration = "1min" | "3min" | "5min";

export interface CategoryDef {
  id: string;
  label: string;
  labelHi: string;
  emoji: string;
}

export const CATEGORIES: CategoryDef[] = [
  { id: "india", label: "India", labelHi: "भारत", emoji: "🇮🇳" },
  { id: "world", label: "World", labelHi: "दुनिया", emoji: "🌍" },
  { id: "business", label: "Business", labelHi: "व्यापार", emoji: "📊" },
  { id: "technology", label: "Technology", labelHi: "प्रौद्योगिकी", emoji: "🔬" },
  { id: "education", label: "Education", labelHi: "शिक्षा", emoji: "🎓" },
  { id: "sports_and_human_interest", label: "Sports", labelHi: "खेल", emoji: "⚽" },
  { id: "culture_and_heritage", label: "Culture", labelHi: "संस्कृति", emoji: "🏛️" },
];

function audioPath(categoryId: string): string {
  return `/audio/categories/${categoryId}.mp3`;
}

export function CategoryBrowser() {
  const [selectedCat, setSelectedCat] = useState<string | null>(null);

  return (
    <div>
      <div className="cat-grid" role="group" aria-label="News categories">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            className={`cat-card ${selectedCat === cat.id ? "active" : ""}`}
            onClick={() => setSelectedCat(selectedCat === cat.id ? null : cat.id)}
            aria-pressed={selectedCat === cat.id}
          >
            <span className="cat-card-emoji">{cat.emoji}</span>
            <span className="cat-card-title">{cat.label}</span>
            <span className="cat-card-hi">{cat.labelHi}</span>
            <span className="cat-card-count">~30s bulletin</span>
          </button>
        ))}
      </div>

      {selectedCat && (
        <div className="audio-panel" aria-label={`${CATEGORIES.find(c => c.id === selectedCat)?.label} audio`}>
          <p className="audio-panel-title">
            {CATEGORIES.find(c => c.id === selectedCat)?.emoji}{" "}
            {CATEGORIES.find(c => c.id === selectedCat)?.label}
            {" — "}
            {CATEGORIES.find(c => c.id === selectedCat)?.labelHi}
          </p>
          <audio controls preload="none" autoPlay>
            <source src={audioPath(selectedCat)} type="audio/mpeg" />
          </audio>
        </div>
      )}

      {!selectedCat && (
        <p className="fixture-footnote" style={{ marginTop: 12 }}>
          Click a category to listen. AI-generated Hindi voice from source-gated claims.
          The Hindu · NDTV · Indian Express.
        </p>
      )}
    </div>
  );
}
